(function () {
  const video = document.getElementById('hero-video');
  if (!video) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;

  const playVideo = () => {
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(() => {
        video.controls = false;
      });
    }
  };

  if (video.readyState >= 2) {
    playVideo();
  } else {
    video.addEventListener('loadeddata', playVideo, { once: true });
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      video.pause();
    } else {
      playVideo();
    }
  });
})();
